<template>
  <div class="home">
    <section id="hero" class="hero section">

      <div id="hero-carousel" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="5000">
        <div 
          class="carousel-item" 
          :class="{ active: index === 0 }" 
          v-for="(item, index) in title" 
          :key="index"
          data-bs-interval="3000"
        >
          <img :src="item.img" class="d-block w-100" alt="Fastana">
        </div>
      </div>
    </section>
    <section class="py-5">
      <div class="container">
        <div class="row justify-content-center ">
          <div class="col-lg-12 ">
            <div id="carouselExampleControls" class="carousel slide shadow-lg rounded-lg overflow-hidden " data-bs-ride="carousel" data-bs-interval="3000" data-aos="fade-up">
              <div class="carousel-inner border-title">
                <div class="carousel-item" v-for="(item, index) in title" :key="index" :class="{ active: index === 0 }">
                  <div class="card border-0 rounded-lg">
                    <div class="card-body p-5 text-center bg-light justify-content-center">
                      <h1 class="card-title font-weight-bold mb-4 text-title" style="font-size: 2.5rem">{{ item.first }} <br> {{ item.second }}</h1>
                      <p class="card-text text-muted fs-5 text-center">{{ item.desc }}</p>
                      <button class="btn mt-3 btn-lokasi" data-bs-toggle="modal" data-bs-target="#modallokasi">{{button}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="featured-services" class="featured-services section d-flex justify-content-center">
      <div class="container">
        <div class="row gy-4 justify-content-center">
          <div class="col-xl-4 col-md-6 " data-aos="fade-up" data-aos-delay="100" v-for="(item, index) in dataLayanan" :key="index">
            <div class="service-item position-relative d-flex flex-column align-items-center">
              <div class="icon rounded-circle p-3 mb-3">
                <i :class="item.icon" style="font-size: 2rem;"></i>
              </div>
              <h4 class="mb-2">
                <p>{{ item.name }}</p>
              </h4>
              <p class="text-center">{{ item.qty.toLocaleString() }} +</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /Hero Section -->
    <div class="modal fade" id="modallokasi" tabindex="-1" role="dialog" aria-labelledby="modallokasiLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header text-dark">
            <h3 class="modal-title text-dark" id="modallokasiLabel" style="font-size: 1.5rem;">Lokasi Gudang FWI</h3>
            <button type="button" class="btn-close text-dark" data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <div class="modal-body">
            <div id="carouselProduk" class="carousel slide" data-bs-ride="carousel">
              <div class="carousel-inner">
                <div class="carousel-item" v-for="(produk, index) in produkList" :key="produk.id" :class="{ active: index === 0 }">
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <h5 class="text-center mb-3">{{ produk.name }}</h5>
                    <img :src="this.image + produk.dc" class="img-fluid mb-3" alt="produk" style="max-height: 300px; object-fit: cover;" />
                    <ul class="list-group list-group-flush w-100">
                      <li class="list-group-item d-flex justify-content-center align-items-center">
                        <a :href="produk.link_maps" target="_blank" class="text-decoration-none ms-1">
                          <i class="bi bi-link-45deg" style="font-size: 1.2rem; color: #0d6efd;"></i>
                          Lokasi Google Maps
                        </a>
                      </li>
                      <li class="list-group-item d-flex justify-content-between align-items-center">
                        Total Pallet
                        <span>{{Intl.NumberFormat('id-ID').format(produk.pallet)}} + Pallet Posisition</span>
                      </li>
                      <li class="list-group-item d-flex justify-content-between align-items-center">
                        Total Karyawan
                        <span>{{Intl.NumberFormat('id-ID').format(produk.employees)}} + Karyawan</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <button class="carousel-control-prev" type="button" data-bs-target="#carouselProduk" data-bs-slide="prev" style="color: black;">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#carouselProduk" data-bs-slide="next" style="color: black;">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BerandaJs from "./js/app.js";
export default BerandaJs;
</script>
